import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesEyeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 14c3.5 0 6.708 3.75 7 5-.292 1.25-3.5 5-7 5s-6.708-3.75-7-5c.292-1.25 3.5-5 7-5m0 3c-1.5 0-2 1-2 2s.5 2 2 2 2-1 2-2-.5-2-2-2"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2c9.625 0 11 1.25 11 10q.002 1.498-.066 2.717l-.059-.052C21.448 13.442 19.365 12.2 17 12.2c-2.364 0-4.448 1.242-5.875 2.465a12.6 12.6 0 0 0-1.839 1.944c-.433.576-.878 1.291-1.039 1.982L8.151 19l.096.41c.161.69.606 1.405 1.04 1.98q.213.285.466.578C2.155 21.736 1 20.018 1 12 1 3.25 2.375 2 12 2M6 12.9h6v-1.8H6zm0-4h12V7.1H6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesEyeFilledSize24Glyph.displayName = 'CardLinesEyeFilledSize24Glyph';
